// eslint-disable-next-line no-undef
const env = process.env.NODE_ENV || 'development'

const baseConfig = {
  /**
   * Indirizzi email a cui è consentito l'accesso
   */
  _A: [
    'bWF0dGlhLmdhbGF0aUBnbWFpbC5jb20=', // mattia.galati@gmail.com
    'YWxlZmViMTk4MUBnbWFpbC5jb20=' // alefeb1981@gmail.com
  ],
  /**
   * Chiave di cifratura solo per ambiente di test
   */
  _K: '7rYq$LK^xMiVf&&!QdHCy%APf$SDCHYLUi@$T2K2qc38rYxpG^',
  // _K:    'uPQFCM8vl8Ln^Qb1T8nFS68sAn!VZPBM#Qqyu@LgBDY00W^bMNq^Bcqf#W9wlEmH*Bl891P#yqe9CA@wjWAqyT*5DlU8kouF@Wm4',
  /**
   * Utente di sviluppo
   */
  _U: 'mattia.galati@gmail.com',
  // _U: 'alefeb1981@gmail.com',
  /**
   * Password di sviluppo
   */
  _P: '123456',
  // _P: '123456',
  /**
   * Ambiente di sviluppo
   */
  ENV: env,
  /**
   * Indica se la configurazione è di sviluppo
   */
  isDev: () => env === 'development',
  /**
   * Configurazione FIREBASE
   */
  FIREBASE: {
    apiKey: 'AIzaSyALSd-_ALy2exKt6fmg4xEy7IkTxKccxuQ',
    authDomain: 'handy-manager.firebaseapp.com',
    databaseURL: 'https://handy-manager.firebaseio.com',
    projectId: 'handy-manager',
    storageBucket: '',
    messagingSenderId: '840834120611',
    appId: '1:840834120611:web:4e1c566ec2ccc655'
  },
  /**
   * Firma vuota
   */
  EMPTY_SIGNATURE:
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAABmJLR0QATQBdAGaZlV4JAAAAC0lEQVQI12NgAAIAAAUAAeImBZsAAAAASUVORK5CYII=',
  /**
   * Sentry
   */
  SENTRY: {
    dsn: 'https://fa49c265d83740c7ba5b91427d90ab94@sentry.io/1811752',
    environment: env,
    // eslint-disable-next-line no-undef
    release: process.env.SENTRY_RELEASE,
    maxBreadcrumbs: 50,
    attachStacktrace: true
  }
}

const config = baseConfig
export default config
